<template>
  <div class="vip">
    <img src="../assets/close.png" alt=""
      style="position: absolute;right: 15px;top: 15px;color: #ffffff;font-size: 20px;" @click="close">
    <div class="head">
      <p>开通云智选VIP，付费激活会员权益</p>
      <p>您身边的高考志愿填报专家</p>
    </div>
    <div class="main flex">
      <!-- <img src="../assets/vip/left.png" alt="" class="left"> -->
      <div class="left">

        <div v-for="(item,index) in list[typeNo].products" :index='index' v-show="current==0">
          <img :src="$imgUrl+item.ico" alt="">
          <div class="left_title">{{item.title}}</div>
          <div class="brief">{{item.brief}}</div>
        </div>
        <div v-for="(item,index) in list[0].products" :index='index' v-show="current==1">
          <img :src="$imgUrl+item.ico" alt="">
          <div class="left_title">{{item.title}}</div>
          <div class="brief">{{item.brief}}</div>
        </div>
      </div>
      <div class="right">
        <div class="tab">
          <span :class="current==0?'active':''" @click="current=0">在线支付</span>
          <span :class="current==1?'active':''" @click="current=1">账号密码激活</span>
        </div>
        <el-carousel :interval="4000" type="card" height="200px" :autoplay='false' @change="changeType" trigger="click"
          v-show="current==0">
          <el-carousel-item v-for="(item,index) in list" :index='index' v-show="item.now_price!=0" :key="index">
            <div class="pay">
              <div class="name">{{item.title}}</div>
              <div class="">
                <span>￥</span><span class="price">{{item.price}}</span> <span v-show="item.now_price==0">(已开通)</span>
              </div>
              <!-- <div class="time">
                有效期：开卡后至考生高考填报志愿完成
              </div> -->
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="flex" style="justify-content: space-between;">

          <!-- <div class="activate" @click="current=1">
            <div class="name">已有实体卡</div>
            <div class="">
              <span></span><span class="price">账号密码激活</span>
            </div>
            <div class="time">
              有效期：开卡后至考生高考填报志愿完成
            </div>
          </div> -->
        </div>
        <div v-show="current==0">
          <div class="ewm">
            <div class="ewmtitle">付款方式</div>
            <div class="way flex">
              <div class="ewm_content">
                <div class="wx" @click="wxpay">
                  <img src="../assets/vip/wx.png" alt="">
                  <span>微信支付</span>
                </div>
              </div>
              <el-divider style="height: 133px;" direction="vertical"></el-divider>
              <div class="ewm_content" style="border:1px solid #06B4FD;">
                <div class="wx" @click="alipay">
                  <img src="../assets/vip/zfb.png" alt="">
                  <span>支付宝支付</span>
                </div>
              </div>
            </div>
            <div class="xieyi"><span style="color: red;">*</span>购买或激活会员即默认你已同意<span style="color:#19CACA;"
                @click="xieyi">《支付协议》</span>
            </div>
          </div>
          <div class="tip">
            <p>1.购买提示：全部功能任意用(部分每年6-8月仅限高三学生使用)</p>
            <p>2.适用对象：初一至高三学生</p>
            <p>3.适用平台：云智选移动端(小程序，h5，APP)以及电脑端</p>
          </div>
        </div>
        <div v-show="current==1">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="激活卡号" style="width: 400px;">
              <el-input v-model="form.card_number"></el-input>
            </el-form-item>
            <el-form-item label="激活卡密码" style="width: 400px;">
              <el-input v-model="form.card_pass"></el-input>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="onSubmit" style="margin-left: 80px;">立即激活</el-button>
          <div class="tip">
            <p>1.购买提示：全部功能任意用(部分每年6-8月仅限高三学生使用)</p>
            <p>2.适用对象：初一至高三学生</p>
            <p>3.适用平台：云智选移动端(小程序，h5，APP)以及电脑端</p>
          </div>
        </div>
      </div>

    </div>
    <el-dialog title="VIP付费用户使用说明" :visible.sync="dialogVisible" width="700px">
      <p v-html="data.content"></p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="微信扫码支付" :visible.sync="wxpayshow" width="340px" :before-close="handleClosePay">
      <div style="margin: auto;" class="qrcode" ref="qrCodeUrl"></div>
    </el-dialog>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  export default {
    data() {
      return {
        data: [],
        typeNo: 0,
        wxpayshow: false,
        url: '',
        dialogVisible: false,
        timer: null,
        vipshow: false,
        current: 0,
        form: {
          card_number: '',
          card_pass: ''
        },
        list: [],
        pack_id: '24'
      }
    },
    components: {
      QRCode
    },
    created() {

    },
    mounted() {
      this.$http.orderPackList().then(res => {
        this.list = res.data.list
      })
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.$store.commit('openVip', false);
    },
    destroyed() {
      clearInterval(this.timer);
      this.$store.commit('openVip', false);
    },
    methods: {
      handleClosePay() {
        this.wxpayshow = false
        clearInterval(this.timer);
      },
      changeType(index) {
        this.typeNo = index
        this.pack_id = this.list[this.typeNo].id
      },
      wxpay() {
        if (this.list[this.typeNo].now_price == 0) {
          this.$message.error('您已开通VIP，无需重复开通！')
          return
        }
        this.$refs.qrCodeUrl = ''
        this.$http.userVipPay({
          order_type: "native",
          pack_id: this.pack_id,
          pay_type: 1
        }).then(res => {
          // this.url = res.data.config.code_url

          this.wxpayshow = true
          this.$nextTick(() => {
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
              text: res.data.config.code_url, // 需要转换为二维码的内容
              width: 300,
              height: 300,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.H
            })
          })
          this.$forceUpdate()
          this.loopOrderState()
        })
      },
      alipay() {
        if (this.list[this.typeNo].now_price == 0) {
          this.$message.error('您已开通VIP，无需重复开通')
          return
        }
        this.$http.userVipPay({
          order_type: "web",
          pack_id: this.pack_id,
          pay_type: 2
        }).then(res => {
          const div = document.createElement('div')
          document.write(res.data.config.content)
        })
      },
      close() {
        clearInterval(this.timer)
        this.$store.commit('openVip', false);
      },
      onSubmit() {
        if (this.form.card_number == '') {
          this.$message.error('请填写卡号')
        } else if (this.form.card_pass == '') {
          this.$message.error('请填写密码')
        } else {
          this.$http.userActive(this.form).then(res => {
            if (res.code == 200) {
              this.$message.success('激活成功')
              this.$store.commit('openVip', false);
            }
          })
        }
      },
      change(num) {
        if (num == 0) {
          this.$http.userVipPay({
            order_type: "native",
            pack_id: this.pack_id
          }).then(res => {
            // this.url = res.data.config.code_url
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
              text: res.data.config.code_url, // 需要转换为二维码的内容
              width: 100,
              height: 100,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.H
            })
            this.loopOrderState()
          })
        } else {
          this.timer = null
        }

      },
      loopOrderState() { //轮询当前订单状态
        this.timer = setInterval(() => {
          this.$http.userOrderPaid({
            pack_id: this.pack_id
          }).then((res) => {
            if (res.data.paid == true) { //10是未支付  20已付款
              clearInterval(this.timer)
              this.$message.success('支付成功，已开通')
              this.$store.commit('openVip', false);
              this.$http.getUserInfo().then((res) => {
                localStorage.setItem('userInfo', JSON.stringify(res.data))
              })
            }
          })
        }, 3000)
      },
      xieyi() {
        this.$http.newsDetail({
          id: 13
        }).then(res => {
          this.data = res.data
          this.dialogVisible = true
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .tab span {
    display: inline-block;
    color: #c73d3d;
    font-size: 20px;
    font-weight: bold;
    padding: 10px;
    text-indent: 0;
    cursor: pointer;
  }

  .active {
    border-bottom: 4px solid #c73d3d;
  }

  .left {
    overflow-y: scroll;
  }

  .left::-webkit-scrollbar {
    width: 7px;
    height: 5px;
  }

  .left::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 2px;
  }

  .left::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 10px;
  }

  .left::-webkit-scrollbar-corner {
    background: #179a16;
  }

  .brief {
    text-align: left;
    font-size: 14px;
    width: 90%;
    margin: 10px auto;
  }

  .left img {
    width: 60px;
    height: 60px;
  }

  .way {
    width: 80%;
    margin: 0 auto;
    justify-content: space-around;
    text-align: center;
  }

  .main {
    margin: 16px;
    align-items: flex-start;
  }

  .form {
    margin: 40px;
  }

  .xieyi {
    margin-top: 40px;
    color: #999999;
    font-size: 12px
  }

  .ewm {
    width: 642px;
    height: 244px;
    background: #FFFFFF;
    border-radius: 10px;
    // margin-top: 17px;
    color: #000000;
    overflow: hidden;


    .ewm_content {
      width: 133px;
      height: 133px;
      background: #FFFFFF;
      border: 1px solid #09BB07;
      border-radius: 10px;
      margin: 17px 0 0 17px;

      img {
        width: 104px;
        height: 104px;
        display: block;
        margin: 15px auto;
      }

      .wx img {
        display: block;
        width: 65px;
        height: 65px;
        vertical-align: middle;
      }
    }

    .ewmtitle {
      margin: 15px 0 0 17px;
      font-weight: bold;
    }
  }

  .tip {
    width: 642px;
    height: 150px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 15px;
    overflow: hidden;
    text-align: left;
    color: #000000;

    p {
      margin: 18px 0 31px 18px;
    }
  }

  .pay {
    width: 314px;
    height: 161px;
    background: url('../assets/vip/pay1.png')no-repeat;
    background-size: cover;
    margin-top: 20px;
    overflow: hidden;
  }

  .left {
    width: 213px;
    height: 679px;
    background: #FFFFFF;
    border-radius: 10px;

    .introduct {}
  }

  .right {
    margin-left: 11px;
    width: 642px;
    text-align: left;
    text-indent: 18px;
    color: #AF671D;

    .price {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #AF671D;
    }

    .time {
      margin-top: 25px;
      font-size: 12px
    }

    .name {
      margin-top: 37px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #AF671D;

      margin-bottom: 22px;
    }
  }

  .activate {
    width: 314px;
    height: 161px;
    background: url('../assets/vip/pay2.png')no-repeat;
    color: #57320C !important;
    background-size: cover;

    .price {
      font-size: 30px
    }

    .time {
      margin-top: 35px;
    }
  }

  .vip {
    width: 900px;
    height: 800px;
    background: #F5F6FA;
    border-radius: 10px;
    position: fixed;
    z-index: 9999;
    left: 50%;
    top: 50%;
    margin-left: -450px;
    margin-top: -380px;
    overflow: hidden;

    .head {
      background-color: #000000;
      width: 100%;
      height: 80px;
      color: #EDC06F;
      overflow: hidden;
      text-align: left;

      &>p:nth-child(1) {
        margin: 17px 0 7px 24px;
        font-weight: bold;
        font-size: 20px
      }

      &>p:nth-child(2) {
        margin: 0px 0 0px 24px;
      }
    }
  }
</style>
<style>
  .el-divider--vertical {
    height: 133px;
  }

  .qrcode img {
    display: inline-block;
  }

  body {
    padding-right: 0px !important;

  }
</style>



// WEBPACK FOOTER //
// src/components/vip.vue